import React, { useRef } from 'react';
const Select = ({
    id,
    title,
    name,
    options,
    value,
    placeholder,
    labelKey,
    valueKey,
    onChange,
    clearOnChange,
    className,
    disabled,
}) => {
    const ref = useRef(null);

    const Placeholder = () => {
        if (!placeholder) return null;
        return (
            <option value='' disabled selected hidden>
                {placeholder}
            </option>
        );
    };

    const onChangeHandler = (e) => {
        if (!disabled) {
            onChange(e.target.value);
            ref.current = clearOnChange ? null : e.target.value;
        }
    };

    const Title = () => {
        if (!title) return null;
        return <label htmlFor={id}>{title}</label>;
    };

    return (
        <div className={`form-group ${className}`}>
            <Title />
            <select
                ref={ref}
                id={id}
                name={name}
                className='form-control'
                onChange={onChangeHandler}
                value={value}
                disabled={disabled}
            >
                <Placeholder />
                {options.map((option, index) => {
                    if (typeof option == 'object') {
                        const { [valueKey]: value, [labelKey]: label } = option;
                        return <option key={`${value}-${index}`} value={value}>{label}</option>;
                    }
                    return <option key={`${option}-${index}`} value={option}>{option}</option>;
                })}
            </select>
        </div>
    );
};

Select.defaultProps = {
    id: undefined,
    title: '',
    name: null,
    options: [],
    placeholder: null,
    valueKey: 'value',
    labelKey: 'label',
    onChange: () => {},
    clearOnChange: false,
    defaultValue: null,
    className: '',
    disabled: false,
};

export default Select;
